import request from '@/util/request'
import { config } from '@/config/config'
export const getWXLocation = params => {
  return request({
    url: config.baseAPI + '/v1/wxlocation/index',
    method: 'get',
    params,
  })
}

export const convert = params => {
  return request({
    url: config.baseAPI + '/v1/amapLocation/convert',
    method: 'get',
    params,
  })
}

export const regeo = params => {
  return request({
    url: config.baseAPI + '/v1/amapLocation/regeo',
    method: 'get',
    params,
  })
}

// 数据模型-查询域->组->模型(级联-三级),如果某个组下没有任何可用的模型,将不予以展示
export const getWarehouseDomainGroupModelMenu = () => {
  return request({
    url: config.oneTableWareAPI + '/api/warehouse/domainGroupModel/menu',
    method: 'get',
  })
}

// 根据模型获取模型下的所有字段
export const getWarehouseDomainGetComponent = modelId => {
  return request({
    url:
      config.oneTableWareAPI +
      `/api/warehouse/domainGroupModel/getComponent/${modelId}`,
    method: 'get',
  })
}

// 数据仓库用户数据匹配列表查询
export const getMatchRelation = params => {
  return request({
    url: config.smartReportAPI + `/api/process/matchRelation`,
    method: 'get',
    params,
  })
}

// 查询用户组
export const getShowRoleList = params => {
  return request({
    url: config.baseAPI + '/v1/role/showRoleList',
    method: 'get',
    params,
  })
}
